export const en = {
  'desk.title': 'Front desk',
  'desk.description': 'Scan a card or look a member up to check them in, sell a plan or book a class.',
  'desk.sellMembership': 'Sell membership',
  'desk.searchLabel': 'Scan a card or search members',
  'desk.searchPlaceholder': 'Scan a card or type a name, number or phone',
  'desk.searchHint': 'A scanned card selects the member straight away. Enter searches, arrow keys pick a result, Esc clears.',
  'desk.pendingCard': 'Card {card} isn’t assigned yet — search a member below and pick them to assign it.',
  'desk.searchResults': 'Search results',
  'desk.noMatch': 'No member matches “{query}”',
  'desk.noMatchHint': 'If this was a card scan, the card is not assigned yet. Look the member up by name and use “Assign card”.',
  'desk.noneSelected': 'No member selected',
  'desk.noneSelectedHint': 'Scan a card or search above. The member’s status, check-in and desk actions appear here.',
  'desk.matchedByCard': 'matched by card',
  'desk.lastVisit': 'Last visit {when}',
  'desk.neverVisited': 'Never visited',
  'desk.today': 'Today',
  'desk.live': 'Live',
  'desk.checkIns': 'Check-ins',
  'desk.denied': 'Denied',
  'desk.sales': 'Sales',
  'desk.salesCount.one': '{count} sale',
  'desk.salesCount.other': '{count} sales',
  'desk.classes': 'Classes',
  'desk.noClassesToday': 'No classes scheduled today.',
  'desk.recentCheckIns': 'Recent check-ins',
  'desk.lastThrough': 'Just came through',
  'desk.nobodyYet': 'Nobody has checked in yet today.',
  'desk.expiringSoon': 'Expiring soon',
  'desk.noneExpiring': 'No memberships end in the next 3 days.',
  'desk.sell': 'Sell',
  'desk.waiting': '{count} waiting',
  'desk.waitlist': 'Waitlist',
  'desk.book': 'Book',
  'desk.member': 'Member',
  'desk.expiredAgo.one': 'Expired {count} day ago',
  'desk.expiredAgo.other': 'Expired {count} days ago',
  'desk.endsToday': 'Ends today',
  'desk.daysLeft.one': '{count} day left',
  'desk.daysLeft.other': '{count} days left',
  'desk.noMembership': 'No membership',
  'desk.ends': 'ends {date}',
  'desk.visitsUsed.one': '{count} visit used',
  'desk.visitsUsed.other': '{count} visits used',
};

export const ka: Record<keyof typeof en, string> = {
  'desk.title': 'მიმღები',
  'desk.description': 'დაასკანერეთ ბარათი ან მოძებნეთ წევრი, რომ შეუშვათ, აბონემენტი მიჰყიდოთ ან ვარჯიშზე ჩაწეროთ.',
  'desk.sellMembership': 'აბონემენტის გაყიდვა',
  'desk.searchLabel': 'დაასკანერეთ ბარათი ან მოძებნეთ წევრი',
  'desk.searchPlaceholder': 'დაასკანერეთ ბარათი ან აკრიფეთ სახელი, ნომერი ან ტელეფონი',
  'desk.searchHint': 'დასკანერებული ბარათი წევრს მაშინვე ირჩევს. Enter ეძებს, ისრებით ირჩევთ შედეგს, Esc ასუფთავებს.',
  'desk.pendingCard': 'ბარათი {card} ჯერ არავისზეა მიბმული — ქვემოთ მოძებნეთ წევრი და აირჩიეთ, რომ ბარათი მას მიება.',
  'desk.searchResults': 'ძიების შედეგები',
  'desk.noMatch': 'წევრი „{query}“ ვერ მოიძებნა',
  'desk.noMatchHint': 'თუ ბარათი დაასკანერეთ, ის ჯერ არავისზეა მიბმული. მოძებნეთ წევრი სახელით და გამოიყენეთ „ბარათის მიბმა“.',
  'desk.noneSelected': 'წევრი არჩეული არ არის',
  'desk.noneSelectedHint': 'დაასკანერეთ ბარათი ან მოძებნეთ ზემოთ. აქ გამოჩნდება წევრის სტატუსი, შემოშვება და სხვა მოქმედებები.',
  'desk.matchedByCard': 'ნაპოვნია ბარათით',
  'desk.lastVisit': 'ბოლო ვიზიტი {when}',
  'desk.neverVisited': 'ჯერ არ მოსულა',
  'desk.today': 'დღეს',
  'desk.live': 'რეალურ დროში',
  'desk.checkIns': 'შესვლები',
  'desk.denied': 'უარი',
  'desk.sales': 'გაყიდვები',
  'desk.salesCount.one': '{count} გაყიდვა',
  'desk.salesCount.other': '{count} გაყიდვა',
  'desk.classes': 'ვარჯიშები',
  'desk.noClassesToday': 'დღეს ვარჯიშები არ არის დაგეგმილი.',
  'desk.recentCheckIns': 'ბოლო შესვლები',
  'desk.lastThrough': 'ახლახან გაიარა',
  'desk.nobodyYet': 'დღეს ჯერ არავინ შემოსულა.',
  'desk.expiringSoon': 'მალე იწურება',
  'desk.noneExpiring': 'მომდევნო 3 დღეში არცერთი აბონემენტი არ მთავრდება.',
  'desk.sell': 'გაყიდვა',
  'desk.waiting': '{count} ელოდება',
  'desk.waitlist': 'მოლოდინის სიაში',
  'desk.book': 'ჩაწერა',
  'desk.member': 'წევრი',
  'desk.expiredAgo.one': 'ვადა გაუვიდა {count} დღის წინ',
  'desk.expiredAgo.other': 'ვადა გაუვიდა {count} დღის წინ',
  'desk.endsToday': 'დღეს მთავრდება',
  'desk.daysLeft.one': 'დარჩა {count} დღე',
  'desk.daysLeft.other': 'დარჩა {count} დღე',
  'desk.noMembership': 'აბონემენტი არ აქვს',
  'desk.ends': 'მთავრდება {date}',
  'desk.visitsUsed.one': 'გამოყენებულია {count} ვიზიტი',
  'desk.visitsUsed.other': 'გამოყენებულია {count} ვიზიტი',
};
